define(
  'app/views/dc_deal_condition_modal_view',['app/setup'],
  function (takhfifan) {

    takhfifan.dcDealConditionModal = takhfifan.BaseView.extend({

      events: {
        'click .tkh-dc-deal-conditions__partner-btn': 'continueCheckout',
      },

      initialize: function (options) {

        takhfifan.eventHub.on('dc:conditionalModal', function (options) {
          this.$el.find(".tkh-dc-deal-conditions-title__text").text(options.title);
          this.$el.find(".tkh-dc-deal-conditions__text").html(options.highlight);
          this.pid = options.pid;
          this.vendorId = options.vendorId;
          this.elementViewObject = options.itemViewObj;
          this.showPopup();
        }, this);

        takhfifan.eventHub.on('modal:disableTriggerElement', function (options) {
          this.$el.hide();
          $('.tkh-dc-deal-conditions-modal__condition-title').removeClass('moreIcon');
        }, this);
      },

      showPopup: function () {
        takhfifan.eventHub.trigger('modal:showModalWithContent',
          {
            triggerElement: this.$el,
            fadeTimeIn: 400,
            elementToOperate: this.$el
          });
        this.$el.show();
      },


      continueCheckout: function () {
        takhfifan.eventHub.trigger('productaddtocart:' + this.pid, this.elementViewObject);
        takhfifan.eventHub.trigger('dc:getDiscount', {productID: this.pid, vendorId: this.vendorId});
      },

    })
  });

